import { useMutation } from "@tanstack/react-query";
import { useGetList, useRefresh } from "react-admin";
import { httpClient, getPartnerAwareApiUrl } from "@/providers/dataProvider/dataProvider";
import type { AggregateBreachCalculation } from "@/types";

export const useAggregateBreachCalculations = (policyId: string | undefined) => {
  const refresh = useRefresh();

  const { data, isLoading, isError } = useGetList<AggregateBreachCalculation>(
    `policies/${policyId}/aggregate-calculations`,
    {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "created_datetime", order: "DESC" },
    },
    { enabled: !!policyId }
  );

  const { mutate: triggerCalculation, isPending: isCalculating } = useMutation({
    mutationFn: async () => {
      const { json } = await httpClient(
        `${getPartnerAwareApiUrl()}/policies/${policyId}/aggregate-calculations/calculate`,
        {
          method: "POST",
        }
      );
      return json as AggregateBreachCalculation;
    },
    onSuccess: () => refresh(),
  });

  return {
    calculations: data ?? [],
    isLoading,
    isError,
    triggerCalculation,
    isCalculating,
  };
};
